import { Suspense, useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { getRoutes } from "./Routes";
import PrivateRoute from "./PrivateRoutes";
import GuestUserRoute from "./GuestUserRoute";
import { MEMBER_TOKEN_KEY } from "../common/authSession";
import Sidebar from "../components/Sidebar/Sidebar";
import MobileSidebar from "../components/Sidebar/MobileSidebar";
import Footer from "../components/Footer/Footer";
import { CommonMessageProvider } from "../common/CommonMessage";
import { registerHttpNavigate } from "../services/http";
import GuestEnrollmentStepMismatchHost from "../common/GuestEnrollmentStepMismatchHost";

const AppRoutes = () => {
  const routes = getRoutes();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    registerHttpNavigate(navigate);
  }, [navigate]);

  const token = localStorage.getItem(MEMBER_TOKEN_KEY);

  useEffect(() => {
    const isOnRoot = location.pathname === "/";
    const isOnPrivatePath = routes.some(
      (route) => route.isPrivate && route.path === location.pathname
    );
    const isGuestPath = location.pathname.startsWith("/guest-user");

    if (token && isOnRoot) {
      navigate("/dashboard");
    } else if (!token && isOnPrivatePath) {
      navigate("/");
    } else if (token && isGuestPath) {
      navigate("/dashboard", { replace: true });
    }
  }, [token, location.pathname, routes, navigate]);

  return (
    <CommonMessageProvider>
      <GuestEnrollmentStepMismatchHost />
      <Suspense>
        <Routes>
          {routes.map((route, index) => (
            <Route
              path={route?.path}
              key={"route_" + index}
              element={
                route?.isLayout && route.isPrivate ? (
                  <PrivateRoute redirectPath="/">
                    <Sidebar />
                    <div className="rightSide">
                      <MobileSidebar />
                      <route.element />
                      <Footer />
                    </div>
                  </PrivateRoute>
                ) : !route?.isLayout && route.isPrivate ? (
                  <PrivateRoute redirectPath="/">
                    <route.element />
                  </PrivateRoute>
                ) : route?.isGuestRoute ? (
                  <GuestUserRoute
                    requireGuestAuth={!!route.guestRouteRequiresAuth}
                  >
                    <route.element />
                  </GuestUserRoute>
                ) : (
                  <route.element />
                )
              }
            />
          ))}
        </Routes>
      </Suspense>
    </CommonMessageProvider>
  );
};

export default AppRoutes;
